<template>
    <div class="auth-invite-admin-register-practice">
        <common-content-spacer height="small">
            <common-button
                :label="$t('pages.auth.invites.buttons.register_practice')"
                class="auth-invite-admin-register-practice__button"
                type="primary"
                @click="emitEvent({ name: 'go-to-practice' })"
            ></common-button>
            <p>{{ $t('pages.auth.invites.buttons.info') }}</p>
        </common-content-spacer>

        <div class="auth-invite-admin-register-practice__text">
            <common-divider>
                <b class="auth-invite-admin-register-practice__header">
                    {{ $t('forms.auth.practice.microcopy.invite_email.header') }}
                </b>
            </common-divider>
            <p class="auth-invite-admin-register-practice__sub-header">
                <common-button
                    :label="$t('forms.auth.practice.microcopy.invite_email.sub_header')"
                    class="auth-invite-admin-register-practice__button"
                    type="secondary"
                    size="large"
                    @click="showForm = !showForm"
                ></common-button>
            </p>
        </div>
        <form-wrapper v-if="showForm" @submit="handleFormSubmission()">
            <common-content-spacer height="large">
                <form-row>
                    <form-cell width="half">
                        <text-field
                            :label="$t('forms.auth.register.fields.first_name.label')"
                            :placeholder="$t('forms.auth.register.fields.first_name.placeholder')"
                            :isRequired="true"
                            :formData="data"
                            valuePath="firstName"
                            @change="change($event)"
                        ></text-field>
                    </form-cell>

                    <form-cell width="half">
                        <text-field
                            :label="$t('forms.auth.register.fields.last_name.label')"
                            :placeholder="$t('forms.auth.register.fields.last_name.placeholder')"
                            :isRequired="true"
                            :formData="data"
                            valuePath="lastName"
                            @change="change($event)"
                        ></text-field>
                    </form-cell>
                </form-row>
                <form-row>
                    <form-cell>
                        <text-field
                            :placeholder="$t('forms.auth.practice.fields.invite_email.placeholder')"
                            :label="$t('forms.auth.practice.fields.invite_email.label')"
                            :isRequired="true"
                            :formData="data"
                            :error="joinInviteId || joinInviteValidationErrorMessage"
                            class="auth-invite-admin-register__input"
                            valuePath="inviteEmail"
                            type="email"
                            @change="change($event)"
                        >
                            <template v-if="joinInviteId" #error>
                                {{ $t('pages.auth.invites.user_already_invited') }}
                                <a @click="sendReminder">
                                    {{ $t('pages.auth.invites.send_reminder') }}
                                </a>
                            </template>
                            <template v-else-if="joinInviteValidationErrorMessage" #error>
                                {{ joinInviteValidationErrorMessage }}
                            </template>
                        </text-field>
                    </form-cell>
                </form-row>
                <div class="signup_invite_modal">
                    <footer>
                        <common-buttons>
                            <common-button
                                :disabled="!data.inviteEmail"
                                :label="$t('pages.auth.invites.buttons.send_request')"
                                :isProcessing="isProcessing"
                                class="auth-invite-admin-register-practice__button"
                                type="secondary"
                                size="large"
                            ></common-button>
                        </common-buttons>
                    </footer>
                </div>
            </common-content-spacer>
        </form-wrapper>
    </div>
</template>

<script>
    import FormMixin from 'mixins/FormMixin'
    import UsersAPI from 'api/UsersAPI'
    import SignupStepService from 'services/SignupStepService'
    import UserRolesEnum from '../../enums/UserRolesEnum'

    export default {
        mixins: [FormMixin],

        data() {
            return {
                joinInviteId: '',
                isProcessing: false,
                joinInviteValidationErrorMessage: '',
                showForm: false,
            }
        },

        methods: {
            handleFormSubmission() {
                this.joinInviteId = ''
                this.joinInviteValidationErrorMessage = ''
                this.isProcessing = true
                const user = this.$auth.getUser()
                UsersAPI.createJoinPracticeInvites({
                    userId: user.id,
                    emails: [{ email: this.data.inviteEmail, firstName: this.data.firstName, lastName: this.data.lastName }],
                    practiceName: user.practiceName,
                    practiceType: user.practiceType,
                    userRoleId: UserRolesEnum.OFFICE_MANAGER.ID,
                })
                    .then((res) => {
                        if (res.emailStatuses[0].status !== 'sent') {
                            this.joinInviteId = `${res.emailStatuses[0].joinInviteId}`
                        } else {
                            SignupStepService.showSignupStep('congratulations')
                            this.emitSent()
                        }
                        this.isProcessing = false
                    })
                    .catch((error) => {
                        const i18nPath = `pages.auth.invites.${error.response.data.subCode.toLowerCase().replace(/\./g, '_')}`
                        this.joinInviteValidationErrorMessage = this.$te(i18nPath)
                            ? this.$t(i18nPath)
                            : error.response.data.message
                    })
            },

            sendReminder() {
                this.isProcessing = true
                UsersAPI.sendReminderForJoinInvite(this.$auth.getUser().id, this.joinInviteId, 'create-practice').then(() => {
                    SignupStepService.showSignupStep('congratulations')
                    this.isProcessing = false
                    this.emitSent()
                })
            },
        },
    }
</script>

<style scoped>
    .auth-invite-admin-register-practice {
        text-align: center;
        margin-top: 40px;
    }

    .auth-invite-admin-register-practice__header {
        color: #333333;
        font-size: 25px;
    }

    .auth-invite-admin-register-practice__sub-header {
        color: #333333;
        font-size: 18px;
        font-weight: 500;
    }

    .auth-invite-admin-register-practice__button {
        min-width: rem(220px);
    }

    .auth-invite-admin-register-practice__text {
        margin: 50px 0;
    }

    .auth-invite-admin-register-practice__info {
        margin-right: 10px;
    }
</style>
